import React from 'react';
import { GiftCardContract } from '../../../types/GiftCard';
import AppliedGiftCard from '../../content/AppliedGiftCard';

interface AppliedGiftCardListProps {
  giftCards: GiftCardContract[];
  onRemoveGiftCardClicked: (giftCard: string) => Promise<void>;
}

const AppliedGiftCardList: React.FC<AppliedGiftCardListProps> = ({
  giftCards,
  onRemoveGiftCardClicked,
}: AppliedGiftCardListProps) => {
  const renderedGiftCards = giftCards.map(giftCard => (
    <AppliedGiftCard
      key={giftCard.code}
      giftCard={giftCard}
      onRemoveGiftCardClicked={onRemoveGiftCardClicked}
    />
  ));
  return <div className="flex flex-col">{renderedGiftCards}</div>;
};

export default AppliedGiftCardList;
